import React, { useCallback } from 'react';

import Button from 'kingpin/atoms/Button';
import FlexCentered from 'components/Common/FlexCentered';
import Typography from 'kingpin/atoms/Typography';

export type UrlAccountErrorReason = 'not-found' | 'deactivated' | 'no-access';

const COPY: Record<UrlAccountErrorReason, { title: string; body: string }> = {
  'not-found': {
    title: 'Account not found',
    body: 'The link references an account that no longer exists. Check the link and try again.',
  },
  deactivated: {
    title: 'Account deactivated',
    body: 'This account has been deactivated and is no longer available.',
  },
  'no-access': {
    title: 'No access to this account',
    body: "You don't have access to this account. If you think this is a mistake, contact your IT admin.",
  },
};

const AccountNotAvailableScreen = ({
  reason,
}: {
  reason: UrlAccountErrorReason;
}) => {
  const { title, body } = COPY[reason];

  const onContinue = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete('accountId');
    window.location.replace(url.toString());
  }, []);

  return (
    <FlexCentered style={{ height: '100vh', gap: 16, padding: 24 }}>
      <Typography.Header type="H1">{title}</Typography.Header>
      <Typography.Body type="Body 12">{body}</Typography.Body>
      <Button
        type="Primary"
        size="Small"
        onClick={onContinue}
        label="Continue to FleetOps"
      />
    </FlexCentered>
  );
};

export default AccountNotAvailableScreen;
